// extracted by mini-css-extract-plugin
module.exports = {"textCardBackground":"text-card_textCardBackground__wUE_h","scrollableCardContent":"text-card_scrollableCardContent__q48ct"};